module.exports = __webpack_public_path__ + "static/media/11-image16.d423703e.jpg";